export default __webpack_public_path__ + "static/media/crash-marker.51023c5d.png";